import { Member } from '@tribeplatform/gql-client/types'
import { Image } from '@tribeplatform/react-components/common/components'

import { getAssetPath } from '../../../configs/static.js'

export const BannerPlaceholder = ({ member }: { member: Member }) => {
  const banners = [
    getAssetPath('images/banners/banner-1.jpg'),
    getAssetPath('images/banners/banner-2.jpg'),
    getAssetPath('images/banners/banner-3.jpg'),
    getAssetPath('images/banners/banner-4.jpg'),
    getAssetPath('images/banners/banner-5.jpg'),
  ]
  let index = 0

  if (member?.id) {
    index = member?.id?.charCodeAt(member?.id?.length - 1) % banners.length
  }
  return <Image src={banners[index]} alt={member?.name} />
}
